import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { fromLonLat } from 'ol/proj.js';
import { defaults as defaultControls } from 'ol/control/defaults.js';

let map; 

export function createMap(properties = {}) {
  if (map) return map; // singleton

  const country = String(properties.country ?? '').trim().toUpperCase();
  const isBelgium = country === '4' || country === 'BE' || country === 'BELGIUM';
  const initialCenter = isBelgium
    ? [4.6667, 50.6403]
    : [5.2913, 52.1326];

  map = new Map({
    target: 'map',
    view: new View({
      center: fromLonLat(initialCenter),
      zoom: 5.5,
    }),
    controls: defaultControls()
  });

  map.setProperties(properties);

  document.dispatchEvent(
    new CustomEvent('map-ready', { detail: map })
  );

  return map;
}

export function getMap() {

  if (!map) {
    console.error('getMap() called before map creation', new Error().stack);
  }

  return map;
}
